import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-factura',
  templateUrl: './modal-factura.component.html',
  styles: [
    `.modal-dialog{
        max-width: 800px !important;
        min-width: 600px !important;
    }

    .modal-body a{
      margin-left:40%;
    }
    `
  ]
})
export class ModalFacturaComponent implements OnInit {

  imagen:string;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
